angular.module('property-deal')
    .controller('PropertyDealSaleReportController', function ($http, $scope, $rootScope, $uibModalInstance, PropertyDeal, $httpParamSerializer) {
        this.reportName = 'Zestawienie sprzedaży - umowy przeniesienia własności (ostateczne)'

        this.$onInit = () => {
            this.form = {
                start: null,
                end: null
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            // return PropertyDeal.statusToggle(this.form).$promise.then(result => {
            //     $rootScope.$broadcast('property-deal.updated', result)
            //     $uibModalInstance.close(this.form)
            // })
        }
        this.reportUrl = () => {
            return '/crm/api/property-deal-export/sale' + $httpParamSerializer(this.form);
        }
    })
